export { default as TextList } from './list'
export type { Props as TextListProps } from './list'
